<template>
  <div>
    <PageAllow controller="FoodTemplates" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <v-text-field
              v-model="templateNameSearch"
              :label="$t('DishTemplate.Fields.template_name')"
              clearable
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="getRecipesFromAPI()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="templateNameSearch = ''"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <v-btn
              small
              color="primary"
              @click.stop="
                currentItem = { id: 0 };
                  currentItemMode = 'new';
              "
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("DishTemplate.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="templates"
          :loading="loading"
          :search="templateNameSearch"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
            <template v-slot:item.dish_setting="{  }">
              <!-- TODO: 菜品模板详情 -->
              <!-- <v-btn
                small
                color="info"
                dark
                class="px-2 me-2"
                :href="'/#/dish-templates/' + (item && item.id ? item.id : 0)"
              > -->
              <v-btn
                small
                color="info"
                dark
                class="px-2 me-2"
              >
                <v-icon x-small class="px-1">fa-align-left</v-icon>
                {{ $t("Opt.details") }}
              </v-btn>
              <!-- <v-btn
                small
                color="primary"
                dark
                class="px-2 me-2"
                :href="
                  '/#/dish-templates/' + (item && item.id ? item.id : 0) + '/edit'
                "
              > -->
              <v-btn
                small
                color="primary"
                dark
                class="px-2 me-2"
              >
                <v-icon x-small class="px-1">fa-highlighter</v-icon>
                {{ $t("CRUD.update") }}
              </v-btn>
            </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('FoodTemplates', 'edit')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-if="item.id"
                  v-bind="attrs"
                  v-on="on"
                  color="accent"
                  class="px-1 me-1"
                  @click.stop="
                    currentItemMode = 'edit';
                    currentItem = item;
                  "
                  >fa-pencil-alt
                </v-icon>
              </template>
              <span>{{
                $t("CRUD.editInfo", [$t("DishTemplate.ObjectName")])
              }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="$permission.permissionAllow('FoodTemplates', 'copy')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-if="item.id"
                  v-bind="attrs"
                  v-on="on"
                  color="warning"
                  class="px-1 me-1"
                  @click.stop="
                    currentItemMode = 'clone';
                    currentItem = item;
                  "
                  >fa-clone
                </v-icon>
              </template>
              <span>{{
                $t("CRUD.cloneInfo", [$t("DishTemplate.ObjectName")])
              }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-if="item.id && item.shop_count == 0"
                  v-bind="attrs"
                  v-on="on"
                  color="danger"
                  class="px-1 me-1"
                  @click.stop="
                    currentItem = item;
                    deleteDialog = true;
                  "
                  >fa-trash-alt
                </v-icon>
              </template>
              <span>{{
                $t("CRUD.deleteInfo", [$t("DishTemplate.ObjectName")])
              }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    </v-slide-x-transition>
    
    
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('DishTemplate.ObjectName')"
      @confirm="
        deleteTemplate();
        deleteDialog = false;
      "
    />
    <DishTemplate
      v-model="currentItem"
      :mode="currentItemMode"
      @mode="currentItemMode = $event"
      @save="getDishTemplatesFromAPI()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogDelete from "@/components/plugins/DialogDelete";
import DishTemplate from "./plugins/DishTemplate";
import DishTemplates from "@/api/dish_templates";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogDelete,
    DishTemplate,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.dishManagement"),
        disabled: false,
        href: "/dishes",
      },
      {
        text: i18n.t("Nav.dishTemplates"),
        disabled: true,
        href: "/dish-templates",
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("DishTemplate.Fields.template_name"),
          align: "start",
          sortable: true,
          filterable: true,
          value: "template_name",
        },
        {
          text: i18n.t("DishTemplate.Fields.dish_count"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "food_count",
        },
        {
          text: i18n.t("DishTemplate.Fields.shop_count", [consts.shopName()]),
          align: "center",
          sortable: false,
          filterable: false,
          value: "shop_count",
        },
        {
          text: i18n.t("DishTemplate.Fields.dish_setting"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "dish_setting",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "actions",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    menu: false,
    editDialog: false,
    deleteDialog: false,
    templates: [],
    templateNameSearch: "",
    currentItemMode: null,
    currentItem: {},
    paging: {},
    options: {},
    serverErrors: [],
  }),

  mounted() {
    this.getDishTemplatesFromAPI();
  },

  methods: {
    getDishTemplatesFromAPI() {
      DishTemplates.fetch().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.templates = response.data.food_templates;
          }
        }.bind(this)
      );
    },
    deleteTemplate() {
      if (this.currentItem)
        DishTemplates.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getDishTemplatesFromAPI(); // 删除成功的话刷新数据
            }
          }.bind(this)
        );
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>